export default "__VITE_ASSET__Dz2u0gu6__"